/// <reference path="./definitions.d.ts"/>
import {GameClientWrapperFactory} from '@gongxigames/framework/integrations/GameClientWrapperFactory';
import {ComponentsConfigs} from '@gongxigames/framework/core';
import {PPGameClientWrapper} from '@gongxigames/framework/integrations/pariplay';
import {
    PokerStartsGameClientWrapper
} from '@gongxigames/framework/integrations/pokerstars/PokerStartsGameClientWrapper';
import {KoalaGameClientWrapper} from '@gongxigames/framework/integrations/koala/KoalaGameClientWrapper';
import {RubyPlayGameClientWrapper} from '@gongxigames/framework/integrations/rubyplay/RubyPlayGameClientWrapper';
import {POPGameClientWrapper} from '@gongxigames/framework/integrations/pop/POPGameClientWrapper';
import {RelaxGameClientWrapper} from '@gongxigames/framework/integrations/relax/RelaxGameClientWrapper';
import {GameClientWrapper} from '@gongxigames/framework/slot';
import {POPUcipGameClientWrapper} from '@gongxigames/framework/integrations/pop-ucip/POPUcipGameClientWrapper';
import {PariplayFusionGameClientWrapper} from '@gongxigames/framework/integrations/fusion/PariplayFusionGameClientWrapper';
import {LightAndWonderGameClientWrapper} from '@gongxigames/framework/integrations/lightAndWonder/LightAndWonderGameClientWrapper';
import {
    LightAndWonderMessageChannel
} from '@gongxigames/framework/integrations/lightAndWonder/LightAndWonderMessageChannel';
import {
    LightAndWonderErrorsHandler
} from '@gongxigames/framework/integrations/lightAndWonder/LightAndWonderErrorsHandler';
import {
    LightAndWonderAPIAdapter
} from '@gongxigames/framework/integrations/lightAndWonder/LightAndWonderAPIAdapter';
import { BetmgmGameClientWrapper } from '@gongxigames/framework/integrations/betmgm/BetmgmGameClientWrapper';
import { ModoGameClientWrapper } from '@gongxigames/framework/integrations/modo/ModoGameClientWrapper';

export const integrationComponentsConfig: ComponentsConfigs = {
    classes: [
        GameClientWrapperFactory,
        PPGameClientWrapper,
        PokerStartsGameClientWrapper,
        KoalaGameClientWrapper,
        RubyPlayGameClientWrapper,
        RelaxGameClientWrapper,
        GameClientWrapper,
        PariplayFusionGameClientWrapper,
        POPGameClientWrapper,
        POPUcipGameClientWrapper,
        LightAndWonderGameClientWrapper,
        BetmgmGameClientWrapper,
        ModoGameClientWrapper
    ],
    singletons: [LightAndWonderMessageChannel, LightAndWonderErrorsHandler, LightAndWonderAPIAdapter]
};
